import React from 'react'
import {
  AUDIT_RESULT,
  AuditReadinessRecord,
  AuditReadinessTestRecord,
  SmartControlTestRecord,
} from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import { AuditBotNotScannedIcon } from 'src/pages/AuditBot/AuditBot.styles'
import {
  CHECK_RESULT_TYPE,
  getCheckResult,
  getCheckResultIcon,
  getControlTestName,
} from 'src/pages/AuditBot/accordion/subsection/ControlChecks/AuditBotControlChecks.helpers'

export const getRoadmapModalTitle = (testName: string): string => {
  return `${getControlTestName(testName)}: Select Controls`
}

export const createControlTestMap = (
  controlTests: SmartControlTestRecord[],
): Record<string, SmartControlTestRecord> => {
  const controlTestMap: Record<string, SmartControlTestRecord> = {}
  controlTests.forEach((controlTest) => {
    controlTestMap[controlTest.getControlId()] = controlTest
  })
  return controlTestMap
}

export const createControlAuditReadinessMap = (
  auditReadinessRecords: AuditReadinessRecord[],
): Record<string, AuditReadinessRecord> => {
  const controlTestMap: Record<string, AuditReadinessRecord> = {}
  auditReadinessRecords.forEach((record) => {
    controlTestMap[record.getControlId()] = record
  })
  return controlTestMap
}

export const getAuditReadinessIcon = (
  check: AuditReadinessRecord,
): JSX.Element => {
  if (!check.getControlTestsList().length) return <AuditBotNotScannedIcon />
  const results = check.getControlTestsList().map((test) => test.getResult())
  return getCheckResultIcon(getCheckResult(results), CHECK_RESULT_TYPE.OVERALL)
}

export const getPercentScanned = (
  records: SmartControlTestRecord[] | AuditReadinessTestRecord[],
): number => {
  const total = records.length
  let scanned = 0
  records.forEach((record) => {
    if (record.getResult() !== AUDIT_RESULT.NOT_RUN) scanned++
  })
  return Math.round((scanned / total) * 100)
}
